import React from "react";
import SafeView from "../../components/safeView/SafeView";
import Tabs from "../../components/Tabs/Tabs";
import {useTabNavigation} from "../../hooks/useTabNavigation";
import tabList from "./reportsTabList";
import ReportHeader from "./reportHeader";

const ReportPage = () => {
  const {activeTab, handleTabChange} = useTabNavigation();

  const defaultActiveTab = activeTab || tabList[0]?.key;

  return (
    <div>
      <SafeView>
        <ReportHeader activeTab={activeTab} />
        <div>
          <Tabs
            defaultActive={defaultActiveTab}
            handleChange={handleTabChange}
            key={defaultActiveTab}
            list={tabList}
          />
        </div>
      </SafeView>
    </div>
  );
};

export default ReportPage;
